var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonOnlyIconreact = function SvgButtonOnlyIconreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 54 \\u2013 209",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 12.611"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 5",
    d: "M10.411 6.63H0v-.643h10.41C13.3 4.622 14.66 3.133 16 0c1.351 3.144 2.71 4.626 5.59 5.984H32v.643H21.589C18.7 7.991 17.35 9.48 16 12.609c-1.351-3.136-2.708-4.619-5.589-5.979Z"
  })));
};

export default SvgButtonOnlyIconreact;